import {
  Grid,
  Paper,
  TextField,
  Typography,
  Popover,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
  Container,
  IconButton,
  useMediaQuery,
  useTheme,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import React, { useEffect, useMemo, useState } from "react";
import { ChromePicker } from "react-color";
import QuantityCounter from "./QuantityCounter/QuantityCounter";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { AllTypoFontStyles } from "../../../../Styles/styles";
import { CloudIcon, MinusIcon, PlusIcon } from "../../../../Svg/icons";
import Ticket from "../CreateTicket/Ticket/Ticket";
import {
  useAddTicketTypeMutation,
  useGetProfileInformationQuery,
  useGetTicketCategoryQuery,
  useGetTicketTypesQuery,
} from "../../../../Redux/apis/ApiSlice";
import { useCreateTicketMutation } from "../../../../Redux/apis/ApiSlice";
import { useDispatch, useSelector } from "react-redux";
import Template1 from "../CreateTicket/Templates/TicketTemplate/Template1";
import Band from "../CreateTicket/Templates/BandTemplate/Band";
import Band1 from "../CreateTicket/Templates/BandTemplate/Band1";
import Band2 from "../CreateTicket/Templates/BandTemplate/Band2";
import Band3 from "../CreateTicket/Templates/BandTemplate/Band3";
import Ticket9 from "../CreateTicket/Templates/TicketTemplate/Ticket9";
import Ticket8 from "../CreateTicket/Templates/TicketTemplate/Ticket8";
import Ticket7 from "../CreateTicket/Templates/TicketTemplate/Ticket7";
import Ticket6 from "../CreateTicket/Templates/TicketTemplate/Ticket6";
import Ticket5 from "../CreateTicket/Templates/TicketTemplate/Ticket5";
import { Input, notification } from "antd";
import { setTicketPayload } from "../../../../Redux/Slices/ticketPayloadSlice";
import { DeleteContentIcon } from "../../../../Svg/icons";
import AddIcon from "@mui/icons-material/Add";
import imageCompression from "browser-image-compression";
import { useNavigate } from "react-router-dom";
import {
  Add,
  Delete,
  DeleteOutline,
  SearchOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
import FeeDeduction from "../../../FeeDeduction/FeeDeduction";

export default function TicketDisplay({ item, onTicketSelect, colors }) {
  const theme = useTheme();
  const ticketPayload = useSelector((state) => state.ticketPayload.payload);

  const [categories, setCategories] = useState([]);
  const [feeDeduction, setFeeDeduction] = useState(
    ticketPayload?.feeDeduction || "Company"
  );
  const isLgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const InputStyles = {
    FieldStyle: {
      height: "47px",
      width: isLgDown ? "100%" : "377px",
    },
  };
  const editEventIfo = useSelector((state) => state.editEventInfo.editEvent);
  const selectedType = useSelector(
    (state) => state.ticketCategory.ticketCategory
  );
  const { data: profileData, refetch } = useGetProfileInformationQuery();
  const [addTicketType] = useAddTicketTypeMutation();
  const { data: ticketTypes } = useGetTicketTypesQuery();
  const [imageURL, setImageURL] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [color, setColor] = useState("");
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [ticketQuantities, setTicketQuantities] = useState({});
  const [ticketPrices, setTicketPrices] = useState({});
  const [code, setCode] = useState(""); // State for 8-digit code
  const [loading, setLoading] = useState(false);
  const [onBoarding, setOnboarding] = React.useState();
  const [ticketTypeStates, setTicketTypeStates] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [redirectToSettings, setRedirectToSettings] = useState(false);

  const { data: getTicketCategory, refetch: refetchTicketCategory } =
    useGetTicketCategoryQuery();
  const [createTicket] = useCreateTicketMutation();

  const [selectedTypes, setSelectedTypes] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const eventId = useSelector((state) => state.eventId.eventId);
  useEffect(() => {
    if (profileData) {
      setOnboarding(profileData.user.onBoarding);
    }
  }, [profileData]);

  // Trigger refetch when returning from onboarding
  useEffect(() => {
    const handleWindowFocus = () => {
      console.log("Window refocused, refetching profile data...");
      refetch(); // Refetch profile data when the window regains focus
    };

    window.addEventListener("focus", handleWindowFocus);
    return () => {
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, [refetch]);

  const ticketCategory = useSelector(
    (state) => state.ticketCategory.ticketCategory
  );
  const selectedTemplate = useSelector(
    (state) => state.selectedTemplate.selectedTemplate
  );
  const eventInfo = useSelector((state) => state.eventInfo.eventInfo);
  const handleAddCategory = () => {
    setCategories([...categories, ""]);
  };
  console.log("Event info:", selectedTypes);
  const ticketData = {
    title: eventInfo?.eventName,
    organizer: eventInfo?.organizationName,
    date: dayjs(eventInfo?.startDateTime).format("MM/DD/YYYY"),
    time: dayjs(eventInfo?.startDateTime).format("hh:mm A"),
    code: "123-456-89",
    location: eventInfo?.location,
    price: "20",
    qrCode: "",
    bgColor: item?.bgColor,
    type: selectedTypes,
    ticketQuantities: ticketQuantities,
    ticketPrices: ticketPrices,
  };
  useEffect(() => {
    console.log("Current ticket data:", editEventIfo.event?.startDateTime);

    if (editEventIfo && editEventIfo?.event?.ticket) {
      const subTickets = editEventIfo?.event?.ticket?.subTickets || [];

      const initialTickets = {};
      const initialQuantities = {};
      const initialPrices = {};

      subTickets.forEach((subTicket) => {
        initialTickets.push(subTicket);
        initialQuantities[subTicket?.ticketTypeId] = subTicket?.quantity || 0;
        initialPrices[subTicket?.ticketTypeId] = subTicket?.price || 0;
      });

      console.log("Initial Quantities from subTickets:", initialQuantities);
      console.log("Initial Prices from subTickets:", initialPrices);
      console.log("Initial Tickets:", initialTickets);

      setSelectedTypes(initialTickets);

      setTicketQuantities(initialQuantities);
      setTicketPrices(initialPrices);
    }

    if (editEventIfo && editEventIfo?.event?.ticket) {
      // Adjust this based on whether `ticket` is an array or object
      const firstTicket = Array.isArray(editEventIfo?.event?.ticket)
        ? editEventIfo?.event?.ticket[0] || {}
        : editEventIfo?.event?.ticket;

      setColor(firstTicket?.color || "#fff");
      setCode(firstTicket?.code || "");
    }
  }, [editEventIfo]);

  const handleQuantityChange = (ticketTypeId, delta) => {
    setTicketQuantities((prev) => ({
      ...prev,
      [ticketTypeId]: Math.max((prev[ticketTypeId] || 0) + delta, 0),
    }));
  };

  const handlePriceChange = (ticketTypeId, delta) => {
    setTicketPrices((prev) => ({
      ...prev,
      [ticketTypeId]: Math.max((prev[ticketTypeId] || 0) + delta, 0),
    }));
  };

  const handleQuantityInputChange = (ticketTypeId, event) => {
    let value = event.target.value;
    if (value.length > 1) {
      value = value.replace(/^0+/, ""); // Remove leading zeros
    }
    const numericValue = value === "" ? "" : Math.max(parseInt(value, 10), 0);

    setTicketQuantities((prev) => ({
      ...prev,
      [ticketTypeId]: numericValue,
    }));
  };
  const navigate = useNavigate();

  const ticketOptions = useMemo(() => {
    return getTicketCategory?.ticketType || [];
  }, [getTicketCategory, editEventIfo]);

  const availableOptions = useMemo(() => {
    return ticketOptions.filter(
      (option) =>
        !selectedTypes.some((t) => t.ticketTypeId === option.ticketTypeId)
    );
  }, [ticketOptions, selectedTypes]);

  const dropdownOptions = useMemo(() => {
    const isAlreadySelected = selectedTypes.some(
      (t) => t.typeName.toLowerCase() === searchValue.toLowerCase()
    );

    if (
      searchValue &&
      !availableOptions.some(
        (option) => option.typeName.toLowerCase() === searchValue.toLowerCase()
      ) &&
      !isAlreadySelected
    ) {
      return [
        { typeName: `Create new "${searchValue}"`, isNew: true },
        ...availableOptions,
      ];
    }

    return availableOptions;
  }, [availableOptions, searchValue, selectedTypes]);

  const handleSelectTicket = async (event, newValue, index) => {
    if (!newValue) return;

    let newTicket = newValue;

    // If it's a new type, create an object with a temporary ID (e.g., "new-xyz")
    if (newTicket.isNew) {
      try {
        const resp = await addTicketType({ typeName: searchValue }).unwrap();

        const newTicketType = resp?.ticketType;

        if (newTicketType) {
          selectedTypes[index] = newTicketType;
          setSelectedTypes([...selectedTypes]);

          setIsUpdated(false);
          await refetchTicketCategory();
        }
      } catch (submitError) {
        console.error(
          "Error creating type:",
          submitError.data?.message || submitError.message
        );
      }
    } else if (newTicket?.ticketTypeId) {
      selectedTypes[index] = newTicket;
      setSelectedTypes([...selectedTypes]);
    }
    setSearchValue("");
  };

  const handlePriceInputChange = (ticketTypeId, event) => {
    // if (onBoarding === false) {
    //   setIsModalOpen(true);
    //   return;
    // }

    let value = event.target.value;
    if (value.length > 1) {
      console.log("value.length", value.length);
      value = value.replace(/^0+/, ""); // Remove leading zeros
    }
    const numericValue = value === "" ? "" : Math.max(parseFloat(value, 10), 0);

    setTicketPrices((prev) => ({
      ...prev,
      [ticketTypeId]: numericValue,
    }));

    if (numericValue)
      setTicketTypeStates((prev) => ({
        ...prev,
        [ticketTypeId]: "Paid",
      }));
  };

  const handleRemoveTicketType = (ticketTypeId) => {
    setSelectedTypes((prev) =>
      prev.filter((ticket) => ticket.ticketTypeId !== ticketTypeId)
    );

    // Remove from state
    setTicketQuantities((prev) => {
      const updated = { ...prev };
      delete updated[ticketTypeId];
      return updated;
    });

    setTicketPrices((prev) => {
      const updated = { ...prev };
      delete updated[ticketTypeId];
      return updated;
    });
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalConfirm = () => {
    // Redirect to settings page
    const state = { from: "login" };
    sessionStorage.setItem("navigationState", JSON.stringify(state));
    window.open("/settings", "_blank");
    setIsModalOpen(false);
  };
  const handleToggleChange = (ticketTypeId, e) => {
    const isFree = e.target.checked;
    setTicketTypeStates((prev) => ({
      ...prev,
      [ticketTypeId]: isFree ? "Free" : "Paid",
    }));
    if (isFree) {
      setTicketPrices((prev) => ({
        ...prev,
        [ticketTypeId]: "",
      })); // Clear price if Free is selected
    }
  };
  const handleCodeChange = (event) => {
    setCode(event.target.value);
  };
  // ---zee
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setLoading(true);
      try {
        const compressedFile = await compressImage(selectedFile);
        const url = `${await uploadToS3(
          compressedFile
        )}?t=${new Date().getTime()}`;
        setImageURL(url);
        setFile({ name: selectedFile.name, url });
        console.log("**first file downloaded");
      } catch (error) {
        console.error("Error uploading file:", error);
      } finally {
        setLoading(false); // End loading
      }
    }
  };
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };
    return imageCompression(file, options);
  };
  const apiUrl = process.env.REACT_APP_API_URL;
  const uploadToS3 = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${apiUrl}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      const result = await response.json();
      return result.Location; // Adjust based on your S3 response structure
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };
  // ----
  const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      setFile(event.dataTransfer.files[0]);
    }
  };
  const [choosenCategory, setChoosenCategory] = useState();
  const dispatch = useDispatch();
  const ticketId = useSelector((state) => state.editTicket);
  const [isUpdated, setIsUpdated] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);

  useEffect(() => {
    if (selectedTypes.length === 0) {
      setSelectedTypes([{ ticketTypeId: "", typeName: "" }]);
    } else {
      if (selectedTypes.length > 1 && !selectedTypes[0].ticketTypeId) {
        selectedTypes.splice(0, 1);
        setSelectedTypes([...selectedTypes]);
      }
    }
  }, [selectedTypes]);

  useEffect(() => {
    if (isUpdated) return;

    console.log("ticketPayload1", ticketPayload);
    setChoosenCategory(ticketPayload?.ticketCategory);
    setImageURL(ticketPayload?.ticketPhoto);

    if (!ticketPayload || !getTicketCategory) return;

    // Initialize state only if it hasn't been set or if it's different
    const initialTypes = [];
    const initialQuantities = {};
    const initialPrices = {};

    getTicketCategory.ticketType.forEach((ticket) => {
      const existingTicket = ticketPayload?.ticketType?.find(
        (payloadTicket) => payloadTicket.ticketTypeId === ticket.ticketTypeId // Matching with ticketTypeId
      );

      if (existingTicket) {
        initialTypes.push(ticket);
        initialQuantities[ticket.ticketTypeId] = existingTicket?.quantity || 0;
        initialPrices[ticket.ticketTypeId] = existingTicket?.price || 0;
      }
    });

    setSelectedTypes((prevTypes) => {
      const updatedTypes = initialTypes.filter(
        (newType) =>
          !prevTypes.some(
            (prevType) => prevType.ticketTypeId === newType.ticketTypeId
          )
      );
      return [...prevTypes, ...updatedTypes];
    });

    // Update ticket quantities without overwriting user edits
    setTicketQuantities((prevQuantities) => {
      const updatedQuantities = { ...prevQuantities };
      Object.keys(initialQuantities).forEach((ticketTypeId) => {
        if (!(ticketTypeId in updatedQuantities)) {
          updatedQuantities[ticketTypeId] = initialQuantities[ticketTypeId];
        }
      });
      return updatedQuantities;
    });

    // Update ticket prices without overwriting user edits
    setTicketPrices((prevPrices) => {
      const updatedPrices = { ...prevPrices };
      Object.keys(initialPrices).forEach((ticketTypeId) => {
        if (!(ticketTypeId in updatedPrices)) {
          updatedPrices[ticketTypeId] = initialPrices[ticketTypeId];
        }
      });
      return updatedPrices;
    });

    if (ticketPayload.color && ticketPayload.color !== color) {
      setColor(ticketPayload.color);
    }

    setIsUpdated(true);
  }, [ticketPayload, getTicketCategory]);

  // Debounce logic to avoid unnecessary dispatching on every state change
  useEffect(() => {
    const timer = setTimeout(() => {
      const ticketTypePayload = Object.keys(ticketQuantities).map(
        (ticketTypeId) => ({
          ticketTypeId: parseInt(ticketTypeId, 10),
          quantity: ticketQuantities[ticketTypeId] || 0,
          price: ticketPrices[ticketTypeId] || 0,
        })
      );

      const payload = {
        ticketId: ticketId.editTicket,
        eventId,
        ticketCategory,
        color,
        ticketType: ticketTypePayload,
        ticketTemplate: selectedTemplate,
        ticketPhoto: imageURL,
        feeDeduction: feeDeduction,
      };
      console.log("Payload** for dispath", payload);
      dispatch(setTicketPayload(payload));
    }, 300); // Wait 300ms before dispatching (debouncing)

    return () => clearTimeout(timer); // Cleanup the timeout on unmount or dependency change
  }, [
    eventId,
    ticketCategory,
    color,
    ticketQuantities,
    ticketPrices,
    selectedTemplate,
    imageURL,
    feeDeduction,
    ticketId,
    dispatch,
  ]);
  const itemStyle = {
    backgroundColor: color,
    padding: "10px",
    textAlign: "center",
    border: "1px solid #ccc",
    borderRadius: "10px",
    position: "relative",
    transition: "background-color 0.3s, border-color 0.3s",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "96px",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorChange = (color) => {
    setColor(color.hex);
  };

  const open = Boolean(anchorEl);
  const id = open ? "color-popover" : undefined;
  //
  const handleOrganiztionSubmit = async () => {
    try {
      // Refetch ticket categories and ensure it's awaited
      const { data: refetchedCategories } = await refetchTicketCategory();
      console.log("Refetched Categories:", refetchedCategories);

      console.log("Categories Before Filtering:", categories);

      // Create a set of existing ticket types from the database
      const existingTypes = new Set(
        ticketTypes.ticketType.map((ticket) => ticket.typeName.toLowerCase())
      );

      // Filter out categories that already exist in the database
      const newCategories = categories.filter(
        (category) =>
          category.trim() && !existingTypes.has(category.trim().toLowerCase())
      );

      const duplicateCategories = categories.filter(
        (category) =>
          category.trim() && existingTypes.has(category.trim().toLowerCase())
      );

      console.log("Duplicate categories found", duplicateCategories);

      let hasError = false;

      // Iterate over new categories and add non-empty ones
      for (const category of newCategories) {
        const trimmedCategory = category.trim();
        if (trimmedCategory) {
          console.log("Submitting Category:", trimmedCategory);
          try {
            await addTicketType({ typeName: trimmedCategory }).unwrap();
            console.log("Submitted Category:", trimmedCategory);
          } catch (submitError) {
            hasError = true;
            console.error(
              "Error submitting category:",
              submitError.data?.message || submitError.message
            );
          }
        }
      }

      // Refetch ticket categories again to get updated list
      await refetchTicketCategory();
      setCategories([""]);
      console.log("New categories successfully submitted");

      // Show notifications based on the results
      if (newCategories.length > 0 && !hasError) {
        notification.success({
          message: "All categories added successfully!",
        });
      }

      if (duplicateCategories.length > 0) {
        notification.warning({
          message: "Duplicate categories found!",
          description: `These categories already exist: ${duplicateCategories.join(
            ", "
          )}`,
        });
      }
    } catch (error) {
      notification.warning({
        message: error.data?.message || error.message,
      });
      console.error(
        "Error submitting categories:",
        error.data?.message || error.message
      );
    }
  };

  const ticketComponents = {
    7: <Template1 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    8: <Ticket5 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    9: <Ticket6 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    10: <Ticket7 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    11: <Ticket8 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    12: <Ticket9 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    13: <Band1 ticket={ticketData} ChangeColor={color} image={imageURL} />,
    14: <Band2 ticket={ticketData} ChangeColor={color} image={imageURL} />,
  };

  const TicketComponent = ticketComponents[item?.id] || (
    <Band3 ticket={ticketData} ChangeColor={color} image={imageURL} />
  );

  const handleDelete = (index) => {
    const newCategories = categories.filter((_, i) => i !== index);
    setCategories(newCategories);
  };

  const handleOpenRemoveDialoge = (ticketTypeId) => {
    setSelectedTicketId(ticketTypeId);
    setOpenRemoveDialog(true);
  };
  const handleCloseRemoveDialoge = () => {
    setSelectedTicketId(null);
    setOpenRemoveDialog(false);
  };

  const handleConfirmDelete = () => {
    if (selectedTicketId) handleRemoveTicketType(selectedTicketId);
    handleCloseRemoveDialoge();
  };

  return (
    <Box sx={{ pb: { xs: 1, md: 6 } }}>
      <Grid sx={{ padding: 2 }}>
        <Grid container md={12} spacing={2}>
          <Grid item md={7} sx={{ overflowX: "hidden" }}>
            <Box
              sx={{
                overflowX: "auto", // Horizontal scroll when content overflows
                width: "100%", // Fit to the screen width
                overflowY: "hidden",
              }}
            >
              <Grid
                sx={{
                  border: "2px solid #e0e0e0",
                  // backgroundColor: "#CFCFCF",
                  // padding: "10px",
                  borderRadius: "1px",
                  minWidth: "600px", // Ensures content doesn't squish below 600px
                  height:
                    selectedType === "Ticket"
                      ? { xs: 210, sm: 250, md: 250, lg: 250, xl: 250 }
                      : "auto",
                }}
              >
                {TicketComponent}
              </Grid>
              <Box
                sx={{
                  textAlign: "right",
                }}
              >
                <Button
                  variant="contained"
                  sx={{ mt: 1, textTransform: "capitalize" }}
                  onClick={() => onTicketSelect(null)}
                >
                  Choose A different template
                </Button>
              </Box>
            </Box>
            <Typography mt={2} mb={1} sx={AllTypoFontStyles.CommonTypo4}>
              Ticket Background Color
            </Typography>
            <Box mb={2}>
              <TextField
                placeholder="Select Color"
                value={color}
                onClick={handleClick}
                fullWidth
                sx={{ height: "46px" }}
                InputProps={{
                  readOnly: true,
                  style: { cursor: "pointer" },
                  endAdornment: (
                    <IconButton>
                      <ColorLensIcon />
                    </IconButton>
                  ),
                }}
              />
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <ChromePicker color={color} onChange={handleColorChange} />
              </Popover>
            </Box>

            <Box>
              <Typography mt={2} mb={1} sx={AllTypoFontStyles.CommonTypo4}>
                Ticket Types
              </Typography>

              <Box sx={{}}>
                {selectedTypes.map((ticket, index) => (
                  <Box key={ticket.ticketTypeId}>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      sx={{
                        m: 0,
                        backgroundColor: "#f9f9f9",
                        // padding: 1,
                        borderRadius: "4px",
                      }}
                    >
                      <Grid item xs={11} md={4}>
                        <Autocomplete
                          freeSolo
                          clearIcon={null}
                          options={dropdownOptions}
                          value={ticket}
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option?.typeName || ""
                          }
                          onInputChange={(event, newValue) =>
                            setSearchValue(newValue)
                          }
                          onChange={(event, value) =>
                            handleSelectTicket(event, value, index)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select or Create"
                              //helperText="Note: You can add multiple types to a ticket."
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchOutlined color="action" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={9} md={3}>
                        <TextField
                          label="Quantity"
                          type="number"
                          disabled={!ticket.ticketTypeId}
                          fullWidth
                          value={ticketQuantities[ticket.ticketTypeId] ?? ""}
                          onChange={(e) =>
                            handleQuantityInputChange(ticket.ticketTypeId, e)
                          }
                        />
                      </Grid>

                      <Grid item xs={9} md={3}>
                        <TextField
                          label="Price"
                          type="number"
                          fullWidth
                          // disabled={!ticketQuantities[ticket.ticketTypeId]}
                          disabled={
                            !ticketQuantities[ticket.ticketTypeId] ||
                            !ticket.ticketTypeId
                          }
                          value={ticketPrices[ticket.ticketTypeId] ?? ""}
                          onChange={(e) =>
                            handlePriceInputChange(ticket.ticketTypeId, e)
                          }
                        />
                      </Grid>

                      {ticket.ticketTypeId && (
                        <Grid item xs={2} md={1}>
                          <IconButton
                            onClick={() =>
                              handleOpenRemoveDialoge(ticket.ticketTypeId)
                            }
                          >
                            <Delete color="error" />
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                    <Divider sx={{ my: 2 }} />
                  </Box>
                ))}
                <Box sx={{ textAlign: "right" }}>
                  {selectedTypes.every((ticket) => ticket.ticketTypeId) && (
                    <Button
                      variant="text"
                      onClick={() =>
                        setSelectedTypes([
                          ...selectedTypes,
                          { ticketTypeId: "", typeName: "" },
                        ])
                      }
                    >
                      Add More
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "none" }}>
              <Typography>Category Name</Typography>

              {categories.map((category, index) => (
                <Grid container md={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: 2,
                    }}
                  >
                    <Input
                      size="large"
                      style={InputStyles.FieldStyle}
                      placeholder="Category Name"
                      value={category}
                      onChange={(e) => {
                        const newCategories = [...categories];
                        newCategories[index] = e.target.value;
                        setCategories(newCategories);
                      }}
                    />
                    <IconButton
                      onClick={() => handleDelete(index)}
                      color="error"
                    >
                      <DeleteContentIcon />
                    </IconButton>
                  </Box>
                </Grid>
              ))}
            </Box>
            <Box sx={{ display: "none" }}>
              <Button
                startIcon={<AddIcon />}
                onClick={handleAddCategory}
                style={{
                  marginBottom: "10px",
                  marginTop: 10,
                  color: "var(--secondary-color)",
                }}
              >
                Add Category
              </Button>
            </Box>
            <Box sx={{ display: "none" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOrganiztionSubmit}
                sx={{
                  backgroundColor: "var(--secondary-color)",
                  "&:hover": {
                    backgroundColor: "var(--primary-color)",
                  },
                }}
              >
                Update
              </Button>
            </Box>
          </Grid>

          <Grid item md={5} sx={{ mt: 2 }}>
            <Box
              my={1}
              sx={{
                border: "2px dashed #ccc",
                borderRadius: 1,
                padding: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: dragOver ? "#e0e0e0" : "#fff",
                cursor: "pointer",
              }}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={handleUploadClick}
            >
              <CloudIcon />
              <Typography variant="body2" color="textSecondary">
                Drag & drop it here
                <br />
                JPEG, PNG, JPG and AVIF formats, up to 50MB
              </Typography>
              <br />
              <strong>
                Your uploaded logo will appear on the ticket template.
              </strong>
              {loading ? (
                <Typography variant="body2" color="textPrimary" sx={{ mt: 2 }}>
                  Loading...
                </Typography>
              ) : file ? (
                <Typography variant="body2" color="primary" sx={{ mt: 2 }}>
                  {file.name}
                </Typography>
              ) : null}
              <input
                id="fileInput"
                type="file"
                accept=".jpeg,.png,.jpg,.avif"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </Box>
            <Box sx={{ mb: 2, textAlign: "center" }}>
              <Button onClick={handleUploadClick} disabled={loading}>
                Upload Logo
              </Button>
            </Box>
          </Grid>
          <Grid item md={12}>
            <FeeDeduction
              setFeeDeduction={setFeeDeduction}
              feeDeduction={feeDeduction}
            />
          </Grid>
        </Grid>
      </Grid>
      <Dialog open={isModalOpen} onClose={handleModalClose}>
        <DialogTitle>Integration Required</DialogTitle>
        <DialogContent>
          <Typography>
            To create a paid event, you must complete the payment onboarding
            process. Please integrate your payment method in the settings first.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleModalConfirm} color="secondary" autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openRemoveDialog} onClose={handleCloseRemoveDialoge}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this ticket type?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRemoveDialoge} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
